const Constants = {
  Payments: {
    CANCELLATION_FEE: 50,
    PAST_DUE_SERVICE_FEE: 75,
    INSTALLMENT_SERVICE_FEE: 3
  },
  LOWES_ID: 14857,
  Purchasing: {
    EXCEEDS_AGGREGATE_ID: 7
  },
  authoDocs: {
    CHEAT_SHEET: 'cheatSheet.xls',
    HVAC_CIL: 'HVAC_CIL_For_Autho2.xlsm'
  },
  helpDocs: {
    PROFILE: 'trainingManual_Profiles.pdf',
    QUOTES_CONTRACTS: 'trainingManual_QuotesContracts.pdf',
    CONTRACT_ACTIONS: 'trainingManual_ContractActions.pdf',
    RENEWAL: 'trainingManual_Renewal.pdf'
  },
  tutorialFiles: {
    AUTOAUTHO_MP4: 'fnhw_auto_autho_walkthrough.mp4',
    AUTOAUTHO_JPG: 'mobile_autho_thumbnail.jpg',
    SWOSTATUS_MP4: 'fnhw_swo_status_walkthrough.mp4',
    SWOSTATUS_JPG: 'mobile_status_update_thumbnail.jpg'
  }
};

export default Constants;



// WEBPACK FOOTER //
// ./src/_constants/Constants.ts